import { UserService } from 'src/app/services/user.service';
import { SigninComponent } from 'src/app/authentication/signin/signin.component';
import { UntypedFormGroup, UntypedFormBuilder, Validators, UntypedFormControl } from '@angular/forms';
import { Component, OnInit } from '@angular/core';
import { MatDialogRef } from '@angular/material/dialog';
import swal from 'sweetalert2';


@Component({
    selector: 'changepassword1-dialog',
    templateUrl: "./changepassword.dialog.component.html",
    styleUrls: ["./changepassword.dialog.component.scss"]
})

export class ChangePasswordDialogExpComponent implements OnInit {
    item: any;
    passwordForm: UntypedFormGroup;
    hide = true;
    chide = true;
    errorMessage: any;
    specialchar: boolean = false;
    strictPasswordPolicy: boolean;
    regexPassed = false;
    repeatedValue = false;
    data;
    user_name;
    constructor(public dialogRef: MatDialogRef<ChangePasswordDialogExpComponent>, private formBuilder: UntypedFormBuilder,
        public userservice: UserService, public loginPage: SigninComponent) {
        this.passwordForm = this.formBuilder.group({
            current_password: ['', Validators.required],
            password: ['', [Validators.required, this.passwordvalidate.bind(this)]],
            cpassword: ['', Validators.required]
        });
    }
    /**
     * Function used to get the required data on component creation
     */
    ngOnInit(): void {
        const retrievedObject = localStorage.getItem("password_policy");
        this.data = JSON.parse(retrievedObject);
        const retrievedObjectuser = localStorage.getItem("user");
        const userdata = JSON.parse(retrievedObjectuser);
        this.user_name=userdata.email;
    }
    /**
     * Function used to validate the password based on different conditions
     * @param c : Password form control
     * @returns : Validation Error
     */
    passwordvalidate(c: UntypedFormControl) {
        if (this.data) {
            this.strictPasswordPolicy = this.data.strictPasswordPolicy;
            const userData = {
                firstName: this.data.firstName?.trim(),
                lastName: this.data.lastName?.trim(),
                email: this.data.userId,
                userId: this.data.userId ? this.data.userId.substr(0, this.data.userId.indexOf('@')) : null,
            }
            let validate = new RegExp(/^(?=.*[A-Z])(?=.*[a-z])(?=.*\d)[A-Za-z\d@$!%*#?&]/);
            if (this.data.password_policy) {
                if (this.data.spec_char_allowed) {
                    validate = new RegExp(/^(?=.*[a-z])(?=.*[A-Z])(?=.*\d)(?=.*[@$!%*?&])[A-Za-z\d@$!%*?&]/);
                    this.specialchar = true;
                }
            }
            switch (true) {
                case this.strictPasswordPolicy: {
                    const checkFirstChar = new RegExp(/[a-zA-Z]/);
                    const firstCharInPassword = c.value.charAt(0);
                    if (validate.test(c.value) && checkFirstChar.test(firstCharInPassword) && c.value.length >= this.data.characterCount) {
                        this.regexPassed = true;
                        const passwordValue = c.value.toUpperCase();
                        return this.passwordCheck(userData, passwordValue);
                    } else {
                        return { 'valid': true }
                    }
                }
                default: {
                    if (validate.test(c.value) && c.value.length >= this.data.characterCount) {
                        this.passwordForm.controls['password'].setErrors(null);
                        return null;
                    } else {
                        return { 'valid': true };
                    }
                }
            }
        }
    }

    /**
     * Function used to check the whether the password has firstName, lastName or email to set the error
     * @param userData : User Data
     * @param c : Password Control
     * @returns : Error
     */
    passwordCheck(userData, passwordValue: string) {
        const useCaseDataChange = {
            firstName: userData.firstName.toUpperCase(),
            lastName: userData.lastName.toUpperCase(),
            email: userData.email.toUpperCase(),
            userId: userData.userId.toUpperCase()
        }
        if ((useCaseDataChange.firstName && passwordValue.includes(useCaseDataChange.firstName)) ||
            (useCaseDataChange.lastName && passwordValue.includes(useCaseDataChange.lastName)) ||
            (useCaseDataChange.email && passwordValue.includes(useCaseDataChange.email)) ||
            (useCaseDataChange.userId && passwordValue.includes(useCaseDataChange.userId))) {
            this.repeatedValue = true;
            this.passwordForm.controls['password'].setErrors({ noMatch: true });
            return this.repeatedValue ? { 'noMatch': true } : { 'noMatch': false };
        } else {
            this.passwordForm.controls['password'].setErrors(null);
            return null;
        }
    }
    /**
     * Function that is invoked on submit of the password and returns success or error message
     * @returns Password changed or not
     */
    async onSubmit() {
        if (this.passwordForm.invalid) {
            return;
        } else if (this.passwordForm.value.password != this.passwordForm.value.cpassword) {
            swal.fire('', "Password do not match. Please try again.", 'warning');

            return;
        } else {
            const obj = {
                newpassword: this.userservice.encryptString(this.passwordForm.value.password, "shbvfbvf"),
                oldpassword: this.userservice.encryptString(this.passwordForm.value.current_password, "shbvfbvf")
            }
            await (await this.userservice.changePasswordexp(obj)).subscribe(_data => {
                swal.fire('', "Password updated successfully", 'warning');
                this.dialogRef.close();
            }, error => {
                this.errorMessage = <any>error;
                swal.fire('', this.errorMessage, 'warning');
            })

        }
    }


    closedelete() {
        this.userservice.signOutOfApp();
        this.dialogRef.close();
    }

    deleteItem() {
        this.dialogRef.close();
    }




}